export default function Contact(props) {
    const contact = props.contact;
    return (
        <li className='contact'>
            {contact.function ? contact.function + ' -- ' : null} {contact.firstname} {contact.name} {contact.phone ? '+' + contact.phone : null}
        </li>
    )
};